import * as types from "./actionTypes";
import * as usersApi from "../../_api/usersApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadStatesSuccess(statesList) {
  return { type: types.LOAD_STATES_SUCCESS, statesList };
}

export function loadStates(CountryID, BrandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return usersApi
      .getStates(CountryID, BrandIdentifier)
      .then((statesList) => {
        if (statesList.length === 0) {
          dispatch(loadStatesSuccess([{ CurrentState: "None" }]));
        } else {
          statesList.sort(
            (
              { ShortName: previousShortName },
              { ShortName: currentShortName }
            ) => previousShortName - currentShortName
          );
          dispatch(loadStatesSuccess(statesList));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadCountiesList(RegionId, Type, BrandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return usersApi
      .getCountyList(RegionId, Type, BrandIdentifier)
      .then((countiesList) => {
        return countiesList;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadProgramTypes(StateOfConviction, UserID) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return usersApi
      .getProgramTypes(StateOfConviction, UserID)
      .then((programTypes) => {
        return programTypes;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
